/* eslint-disable react/prop-types */
import React, { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LetterTemplateCard from '@/views/pages/Templates/elements/LetterTemplateCard';
import Spinner from '@/views/components/Spinner/Spinner';

import { ModalContext } from '@/utils/contexts/ModalContext';

import styles from '@/views/pages/Templates/elements/LetterTemplateCardsContainer.module.scss';

const LetterTemplatesContainer = ({ 
	templateData,
	isLoading,
	onConfirmDeleteTemplate,
}) => {
	const { dict } = useSelector((state) => state.app);
	const navigate = useNavigate();

	const { showModal } = useContext( ModalContext );

	const onEditItem = useCallback((templateId) => {
		navigate(`/edit-template/${templateId}`);
	}, [ navigate ]);

	const onDeleteItem = useCallback( (templateId) => {
		showModal({
			componentName: 'ModalDeleteTemplate',
			additionalInfo: {
				id: templateId,
				callbackFunction: onConfirmDeleteTemplate,
			},
		});
	}, []);

	return (
		<section className={ styles['template-card-container'] }>
			{ templateData && !isLoading && templateData.map((template, index) => {
				return (
					<LetterTemplateCard
						key={ template.title + index }
						templateData={ template }
						onDeleteItem={ onDeleteItem }
						onEditItem={ onEditItem }
					/>
				);

			})}
			{ (!templateData || isLoading) && (
				<Spinner addClass='table__spinner' />
			)}
			{ templateData && templateData.length === 0 && (
				<div className='table__no-elements'>
					{ dict.templates.noElements }
				</div>
			)}
		</section>
	);
};
export default LetterTemplatesContainer;